import { render, staticRenderFns } from "./Approvals.vue?vue&type=template&id=fbe0e976&scoped=true"
import script from "./Approvals.vue?vue&type=script&lang=js"
export * from "./Approvals.vue?vue&type=script&lang=js"
import style0 from "./Approvals.vue?vue&type=style&index=0&id=fbe0e976&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe0e976",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbe0e976')) {
      api.createRecord('fbe0e976', component.options)
    } else {
      api.reload('fbe0e976', component.options)
    }
    module.hot.accept("./Approvals.vue?vue&type=template&id=fbe0e976&scoped=true", function () {
      api.rerender('fbe0e976', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/professional/Approvals.vue"
export default component.exports